document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.play-pause-btn').forEach((playPauseBtn) => {
    const video = playPauseBtn.closest('.media-overlay-video-container').querySelector('video');
    let isPlaying = !video.paused;

    playPauseBtn.classList.add(video.paused ? 'play-btn' : 'paused-btn');

    playPauseBtn.addEventListener('click', () => {
      if (isPlaying) {
        video.pause();
      } else {
        video.play().catch((error) => {
          console.error('Video play error:', error);
        });
      }
      isPlaying = !isPlaying;
    });

    video.addEventListener('play', () => {
      playPauseBtn.classList.remove('play-btn');
      playPauseBtn.classList.add('paused-btn');
      isPlaying = true;
    });

    video.addEventListener('pause', () => {
      playPauseBtn.classList.remove('paused-btn');
      playPauseBtn.classList.add('play-btn');
      isPlaying = false;
    });
  });
});